export interface ISmartIdInteraction {
    type: string;

    displayText60?: string;

    displayText200?: string;
}

export class SmartIdInteractionTypes {
    public static readonly DISPLAY_TEXT_AND_PIN = "displayTextAndPIN";
    public static readonly CONFIRMATION_MESSAGE = "confirmationMessage";
    public static readonly VERIFICATION_CODE_CHOICE = "verificationCodeChoice";
    public static readonly CONFIRMATION_MESSAGE_AND_VERIFICATION_CODE_CHOICE = "confirmationMessageAndVerificationCodeChoice";
}